/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Visit_LabelInputs */

const en_price_page_visit_label = /** @type {(inputs: Price_Page_Visit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visits with a specialist`)
};

const pl_price_page_visit_label = /** @type {(inputs: Price_Page_Visit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wizyty u specjalisty`)
};

/**
* | output |
* | --- |
* | "Visits with a specialist" |
*
* @param {Price_Page_Visit_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_visit_label = /** @type {((inputs?: Price_Page_Visit_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Visit_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_visit_label(inputs)
	return en_price_page_visit_label(inputs)
});